import LeftSideBar from '../../components/LeftSideBar';
import Title from '../../components/Title';

export const DiligenceServices = () => {
  return (
        <div className='services_main_wrapper'>
            <div className='container'>
                <div className='row mt-5 mb-5'>
                    <div className='col-md-3  column_height'>
                        <LeftSideBar/>
                    </div>
                    <div className='col-md-9'>
                        <div className='right_side_content'>
                            <div className='section_main_title d-flex align-items-center justify-content-between'>
                                <div className='title_and_icon d-flex align-items-center'>
                                    <img src='/images/gst_icon.jpg'></img>
                                    <Title text="GST Due Diligence Services" className="custom-heading" />
                                </div>
                                <ul className='d-flex align-items-center'>
                                    <li className='green'>accuracy</li>
                                    <li className='orange'>foresight</li>
                                    <li className='light-blue'>assurance</li>
                                </ul>
                            </div>
                            <div className='content-wrap discriptions'>
                                <p>In today’s dynamic regulatory environment, businesses face constant challenges in maintaining compliance with GST regulations. GST Due Diligence is not just a precautionary measure but a strategic tool for identifying tax risks, ensuring compliance, and optimizing tax efficiencies. Whether you are preparing for a merger, acquisition, audit, or business restructuring, <strong>Vanani & Associates</strong> offers expert GST Due Diligence services tailored to safeguard your business from potential tax risks while uncovering opportunities for growth.</p>
                                <p>Our experienced professionals conduct a meticulous review of your GST compliance framework, records, and processes. By identifying gaps, mitigating risks, and providing actionable recommendations, we ensure that your business remains compliant, resilient, and ready to handle any regulatory scrutiny.</p>
                            </div>  

                            <div class="scroll-indicator">
                                <div class="scroll-progress" id="scrollProgress"></div>
                            </div>

                            <div class="floating-elements">
                                <div class="floating-circle circle-1"></div>
                                <div class="floating-circle circle-2"></div>
                                <div class="floating-circle circle-3"></div>
                                <div class="floating-circle circle-4"></div>
                            </div>

                            {/* Style  01*/}
                                <div class="container p-0">
                                    <div class="header">
                                        <h1>GST Due Diligence Services</h1>
                                        <p class="subtitle text-center">Comprehensive compliance solutions for your business</p>
                                    </div>

                                    <div class="services-grid-wrap mt-4">
                                        <div class="service-card">
                                            <div class="service-number">1</div>
                                            <h2 class="service-title">Comprehensive GST Compliance Review</h2>
                                            <p class="service-description">
                                                Our experts undertake an in-depth review of your GST records to ensure accurate reporting and compliance.
                                            </p>
                                            
                                            <ul class="features-list">
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Examination of past GST returns, including <span class="highlight">GSTR-1, GSTR-3B, GSTR-9, and GSTR-9C</span>, for discrepancies.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Validation of <span class="highlight">Input Tax Credit (ITC)</span> claims against invoices, purchase records, and GSTR-2A/2B.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Cross-verification of <span class="highlight">outward and inward supplies</span> to ensure accurate tax treatment and reporting.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Review of <span class="highlight">e-way bills</span>, HSN codes, and SAC codes for proper classification and adherence to GST laws.
                                                    </div>
                                                </li>
                                                <li className='mb-0'>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Assessment of compliance with <span class="highlight">Reverse Charge Mechanism (RCM)</span> provisions, ensuring taxes are paid correctly for applicable transactions.
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="service-card risk-section">
                                            <div class="service-number">2</div>
                                            <h2 class="service-title">Identification of GST Risks</h2>
                                            <p class="service-description">
                                                We analyze your compliance framework to uncover potential risks and liabilities.
                                            </p>
                                            
                                            <ul class="features-list">
                                                <li>
                                                    <div class="feature-icon">⚠</div>
                                                    <div class="feature-text">
                                                        Detection of errors in GST filings, ITC claims, and tax payments.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">⚠</div>
                                                    <div class="feature-text">
                                                        Identification of unresolved disputes, pending liabilities, or procedural lapses.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">⚠</div>
                                                    <div class="feature-text">
                                                        Evaluation of penalties, interest liabilities, or risks associated with non-compliance.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">⚠</div>
                                                    <div class="feature-text">
                                                        Analysis of mismatches in <span class="highlight">GSTR-1, GSTR-3B</span>, and financial statements to prevent future discrepancies.
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="service-card">
                                            <div class="service-number">3</div>
                                            <h2 class="service-title">Review of Financial Records for GST Compliance</h2>
                                            <p class="service-description">
                                                We ensure alignment between your financial statements and GST returns for complete accuracy:
                                            </p>
                                            
                                            <ul class="features-list">
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                    Correlation of financial records with GST returns to identify inconsistencies.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Verification of GST applicability on transactions like  <span class="highlight">inter-branch transfers, exports, imports, and deemed supplies.</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Analysis of  <span class="highlight">contractual and agreement terms </span> to ensure GST provisions are appropriately implemented.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Assessment of GST compliance in niche areas like free-of-cost supplies, warranty claims, or employee recoveries.
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="service-card">
                                            <div class="service-number">4</div>
                                            <h2 class="service-title">Risk Mitigation and Strategic Recommendations</h2>
                                            <p class="service-description">
                                                Our professionals provide actionable insights to mitigate risks and optimize GST compliance:
                                            </p>
                                            
                                            <ul class="features-list">
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                    Identifying opportunities for <span class="highlight">ITC maximization</span> to improve cash flow and reduce liabilities.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Strategic advice on rectifying past errors in GST filings and ensuring adherence to future compliance requirements.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Recommendations on addressing notices, summons, or pending liabilities to minimize financial exposure.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Implementing processes and systems to avoid repeat non-compliance issues.
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="service-card">
                                            <div class="service-number">5</div>
                                            <h2 class="service-title">Audit and Assessment Support</h2>
                                            <p class="service-description">
                                                Our team ensures smooth handling of audits and assessments conducted by GST authorities:
                                            </p>
                                            
                                            <ul class="features-list">
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                    Assistance in preparing required documentation, reports, and explanations for GST audits.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Representation during audits, inquiries, or assessments to address queries raised by authorities.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                    Support in responding to <span class="highlight">notices, scrutiny, and summons</span> from tax departments.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="feature-icon">✓</div>
                                                    <div class="feature-text">
                                                        Proactive handling of mismatches or disputes highlighted during audits to prevent penalties.
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            <div className='main_back_clr p-4 mt-0 check_list_wrap'>
                                <h4 class="font-weight-600 mb-3">Why Choose <sapn class="key_features">Vanani & Associates</sapn></h4>
                                <ul className='mb-0'>
                                    <li><strong>Strategic Consulting:</strong>We offer advisory and strategic consulting assistance to evaluate the impact of indirect taxes on your products and services, ensuring optimized tax strategies. </li>
                                    <li><strong>Comprehensive GST Services:  </strong>From registration and tax code classification to filing returns and obtaining refunds, we offer end-to-end GST services. Our experts provide litigation and representation support, GST due diligence, and other advisory services.</li>
                                    <li><strong>Employee Training: </strong>We conduct training sessions for your employees to enhance their understanding of GST provisions and improve compliance handling.</li>
                                    <li><strong>Expert Litigation Support: </strong>Our legal advisors and indirect tax consultants provide robust litigation support services, including filing writ petitions, handling assessment proceedings, processing refund applications, and representing you before tax authorities.</li>
                                </ul>
                            </div>

                            <div className='discriptions mt-4 high-light-msg'>
                                <p>Partner with <b>Vanani & Associates</b> to gain confidence in your GST compliance and future-proof your business against potential tax risks. Let us simplify GST for you—contact us today to get started!</p>
                            </div>

                        </div>  
                    </div>
                </div>
            </div>
        </div>
      )
    }
    
export default DiligenceServices;